/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'plus': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" _fill="#4C5EE1" d="M10.025 7.975h6.95a1.025 1.025 0 110 2.05h-6.95v6.95a1.025 1.025 0 11-2.05 0v-6.95h-6.95a1.025 1.025 0 110-2.05h6.95v-6.95a1.025 1.025 0 112.05 0v6.95z"/>'
  }
})
